export const DROPDOWN_CONTENT_CONFIG = {
    // positioning
    side: 'bottom' as const,
    sideOffset: 4,
    collisionPadding: 16,

    // animation
    animationDuration: 0.2,
    animationTiming: 'ease-out' as const,
} as const;
